import { Checkbox, Input, Checkmark, OptionLabel } from "./styles";
import { useLayout } from "../../../../../../provider/LayoutProvider";

const Filter = ({ label, value, name, ...rest }) => {
  const { applyedFilters, setFilters } = useLayout();
  const isChecked = !!applyedFilters[name]?.includes(value);

  return (
    <Checkbox>
      <Input
        type="checkbox"
        id={name + "-" + value}
        name={name}
        value={value}
        checked={isChecked}
        onChange={(event) => {
          if (isChecked) {
            setFilters(name, value, "REMOVE");
          } else {
            setFilters(name, value, "ADD");
          }
        }}
        {...rest}
      />
      <OptionLabel htmlFor={name + "-" + value}>
        <Checkmark />
        {label}
      </OptionLabel>
    </Checkbox>
  );
};

export default Filter;
